import type { FunctionComponent, ReactElement } from 'react';
import type { MessageFormatterReturnType } from '@/domains/core/localization/translate';
interface Props {
  productsElement: JSX.Element[];
  title?: MessageFormatterReturnType<JSX.Element>;
  button?: ReactElement<{
    className: string;
  }>;
}
export const ProductsContainer: FunctionComponent<Props> = ({
  productsElement,
  title,
  button
}) => {
  return <div>
      {title}
      <div className="mt-s grid grid-cols-3 gap-s">{productsElement}</div>
      {button && <div className="mt-s flex justify-end">{button}</div>}
    </div>;
};
ProductsContainer.displayName = 'ProductsContainer';